const historyLogUserAction = {
	create: 1,
	update: 2,
	delete: 3,
};

const historyLogSource = {
	fulfillmentOrder: 1,
	product: 2,
	marketplaceOrder: 3,
	receiving: 4,
};

const historyLogListFields = ['UPC', 'Product Virtual SKU']; // matches history log constants on the backend

export { historyLogUserAction, historyLogSource, historyLogListFields };



// WEBPACK FOOTER //
// ./src/common/constants/historyLogConstants.js